module.exports = __webpack_public_path__ + "img/search-header-with-nav-kia.9225ab71.png";